import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const DeveloperSettingsPage = lazy(() => import('.'))

class DeveloperSettingsPageWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['team-id', 'team-uuid']
  }

  override render() {
    const teamId = this.prop('team-id') ?? ''
    const teamUuid = this.prop('team-uuid') ?? ''

    return (
      <PageRoot>
        <DeveloperSettingsPage teamId={teamId} teamUuid={teamUuid} />
      </PageRoot>
    )
  }
}

customElements.define('developer-settings-page', DeveloperSettingsPageWebComponent)
